
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'GestationalHypertension',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Card/GestationalHypertension.vue